import * as React from 'react';
import { reduxForm, Field, getFormSyncErrors } from 'redux-form';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { ErrorSummary, Modal, Button, WhiteButton } from 'components';
import * as c from 'models/constants';
import { PortalInputField } from 'components/FormControls';
import { requestFailure } from 'redux/modules/image';
import { ButtonsSection } from 'components/PortalStructure';
import { InjectedFormProps, ITranslateProps } from 'models/common';
import { required } from 'helpers/validationattributes';
import { Dispatch } from 'react-redux';
import { closeModal } from 'redux/modules/modal';
import { IUserPaymentMethod } from 'models/user/userpayments';
import { addPaymentMethod } from 'redux/modules/user/userpaymentmethods';
require('./style.scss');

interface IProps
	extends InjectedFormProps<IUserPaymentMethod>,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {}

const fieldNames: { [key in keyof IUserPaymentMethod]: key } = {
	cardNumber: 'cardNumber',
	expirationDate: 'expirationDate',
	cvc: 'cvc',
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AddPaymentMethodModalForm extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	public onSubmit(formRaw: any) {
		const form: IUserPaymentMethod = { ...formRaw };

		this.props.addPaymentMethod(form);
	}

	private mapErrorKeyToMessage(key: string) {
		switch (key) {
			default:
				return key;
		}
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { handleSubmit, t, formErrors, submitFailed } = this.props;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		const form = (
			<>
				<div className="row">
					<Field
						className="col-12 mb-3"
						name={fieldNames.cardNumber}
						component={PortalInputField}
						type="text"
						label={t('UserPaymentMethod_CardNumber')}
						list="addAppointmentModalCustomers"
						validate={[required]}
					/>
				</div>
				<div className="row">
					<Field
						className="col-6 pr-2"
						name={fieldNames.expirationDate}
						component={PortalInputField}
						type="text"
						label={t('UserPaymentMethod_ExpirationDate')}
						validate={[required]}
					/>
					<Field
						className="col-6 pl-2"
						name={fieldNames.cvc}
						component={PortalInputField}
						type="text"
						label={t('CVC')}
					/>
				</div>
			</>
		);

		const footer = (
			<ButtonsSection>
				<WhiteButton onClick={this.props.closeModal}>{t('BSPortal_Common_Cancel')}</WhiteButton>
				<Button disabled={this.props.submitting || !this.props.dirty} onClick={handleSubmit(this.onSubmit)}>
					{t('BSPortal_Common_Save')}
				</Button>
			</ButtonsSection>
		);

		return (
			<Modal
				modalClass="modal-with-form add-payment-method-modal"
				title={t('UserPaymentMethod_Add_Payment_Method_Title')}
				closeModal={this.props.closeModal}
				size="medium"
				showHeaderCloseButton={true}
				footerPaddingMatchBody={true}
				footer={footer}
			>
				<p className="p14">{t('UserPaymentMethod_Enter_Bank_Details')}</p>
				<form onSubmit={handleSubmit(this.onSubmit)} autoComplete="off">
					{form}
				</form>
				<div>
					<ErrorSummary {...errorSummaryProps} />
				</div>
			</Modal>
		);
	}
}

function mapStateToProps(state: IStore) {
	return {
		formErrors: getFormSyncErrors(c.FORM_NAME_MANUAL_APPOINTMENT)(state),
	};
}

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	requestFailure: (error) => dispatch(requestFailure(error)),
	addPaymentMethod: (form: IUserPaymentMethod) => dispatch(addPaymentMethod(form)).then(() => dispatch(closeModal())),
	closeModal: () => {
		dispatch(closeModal());
	},
});

let AddPaymentMethodModal = reduxForm(
	{
		form: c.FORM_NAME_MANUAL_APPOINTMENT,
		destroyOnUnmount: true,
		enableReinitialize: true,
	},
	mapStateToProps,
)(AddPaymentMethodModalForm);

AddPaymentMethodModal = connect(mapStateToProps, mapDispatchToProps)(AddPaymentMethodModal);

export { AddPaymentMethodModal };
